// Redux hooks and selectors
import { useAppSelector } from '../../../redux/hooks/useAppSelector';
import { selectIsDarkMode } from '../../../redux/selectors/displaySettingsSelectors';
import { colors } from '../../../common/constants/designTokens';

/**
 * Hook to get consistent chart colors based on theme.
 * The single source of chart colors — do not hard-code hexes in chart components.
 * @returns {Object} - An object containing chart colors
 */
export const useChartColors = () => {
  const isDarkMode = useAppSelector(selectIsDarkMode);

  return {
    primary: colors.primary[900], // Darkest green in both themes
    secondary: colors.primary[500], // Main green in both themes
    text: isDarkMode ? colors.text.primaryDark : colors.gray[700],
    grid: isDarkMode ? colors.primary[500] : colors.gray[200],
    background: isDarkMode ? colors.indigo[500] : colors.white,
    barBackground: isDarkMode ? colors.indigo[600] : colors.gray[100],
    tooltip: {
      background: isDarkMode ? colors.indigo[600] : colors.white,
      border: isDarkMode ? colors.primary[500] : colors.gray[200],
      text: isDarkMode ? colors.text.primaryDark : colors.gray[900],
    },
    // Semantic series colors for status-shaped data (scheduled/processing/sent/failed, etc.)
    status: {
      info: colors.primary[500],
      success: colors.success[500],
      warning: colors.secondary.main,
      error: colors.error[500],
      errorMuted: colors.error[400],
    },
    // Hover ring stroke for pie slices (see usePieActiveCell)
    pieActiveStroke: colors.primary[25],
  };
};
